// extracted by mini-css-extract-plugin
export default {"field":"SetInventory_field__Azkit","requiredIcon":"SetInventory_requiredIcon__hXcIr"};